import { render, staticRenderFns } from "./VocationalEdu.vue?vue&type=template&id=45d11b4f"
import script from "./VocationalEdu.vue?vue&type=script&lang=js"
export * from "./VocationalEdu.vue?vue&type=script&lang=js"
import style0 from "./VocationalEdu.vue?vue&type=style&index=0&id=45d11b4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports